"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const uicon_flag_fill_style_1 = __importDefault(require("./uicon.flag.fill.style"));
class UiconFlagFill extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, size } = this.props;
            return (jsx_runtime_1.jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fillRule: "evenodd", viewBox: "0 0 32 32", "aria-hidden": "true", className: classes.root, style: { width: size, height: size } }, { children: jsx_runtime_1.jsx("path", { fillRule: "nonzero", d: "M1.698 12.2L1.367 2.033c.001-.386.391-.715.924-.78 3.241-.54 6.648-.189 9.543.984 1.302.584 2.484 1.295 3.511 2.112.987.764 2.118 1.427 3.36 1.968 3.233 1.251 7.083 1.397 10.483.396.336-.075.702-.035.991.108.284.149.452.385.454.636v14.496c-.004.325-.283.615-.706.732-4.368 1.2-8.198 1.068-11.373-.252-1.188-.512-2.269-1.142-3.209-1.872-1.089-.856-2.345-1.596-3.73-2.196-2.169-.89-4.653-1.299-7.137-1.18v13.809h-2.78V12.2z" }, void 0) }), void 0));
        };
    }
}
UiconFlagFill.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    size: prop_types_1.default.number
};
UiconFlagFill.defaultProps = {
    size: null
};
exports.default = react_jss_1.default(uicon_flag_fill_style_1.default)(UiconFlagFill);
//# sourceMappingURL=uicon.flag.fill.js.map